import { render, staticRenderFns } from "./staff-item.vue?vue&type=template&id=7724feac&scoped=true"
import script from "./staff-item.vue?vue&type=script&lang=js"
export * from "./staff-item.vue?vue&type=script&lang=js"
import style0 from "./staff-item.vue?vue&type=style&index=0&id=7724feac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7724feac",
  null
  
)

export default component.exports